export default __webpack_public_path__ + "static/media/empty-list-seagull-transparent.25518070.png";